<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center m-3 pb-2 globalborder-btm-header">
        <h2 class="mb-0">Dashboard Setting</h2>
      </span>

      <div class="col-12 px-3">
        <div class="row mt-3">
          <div class="col-3 fixed-width mb-4">
            <div class="form-group has-float-label">
              <label class="form-label" for="quadreport1">Quad Report 1</label>
              <p-select
                [options]="dashboradReports1"
                [(ngModel)]="quadreport1"
                (onChange)="onReportSelection1($event)"
                optionLabel="name"
                optionValue="name"
                optionDisabled="status"
                placeholder="Quad Report 1">
              </p-select>
            </div>
          </div>
          <div class="col-3 fixed-width mb-4">
            <div class="form-group has-float-label">
              <label class="form-label" for="quadreport2">Quad Report 2</label>
              <p-select
                [options]="dashboradReports2"
                [(ngModel)]="quadreport2"
                (onChange)="onReportSelection2($event)"
                optionLabel="name"
                optionValue="name"
                optionDisabled="status"
                placeholder="Quad Report 2">
              </p-select>
            </div>
          </div>
          <div class="col-3 fixed-width mb-4">
            <div class="form-group has-float-label">
              <label class="form-label" for="quadreport3">Quad Report 3</label>
              <p-select
                [options]="dashboradReports3"
                [(ngModel)]="quadreport3"
                (onChange)="onReportSelection3($event)"
                optionLabel="name"
                optionValue="name"
                optionDisabled="status"
                placeholder="Quad Report 3">
              </p-select>
            </div>
          </div>
          <div class="col-3 fixed-width mb-4">
            <div class="form-group has-float-label">
              <label class="form-label" for="quadreport4">Quad Report 4</label>
              <p-select
                [options]="dashboradReports4"
                [(ngModel)]="quadreport4"
                (onChange)="onReportSelection4($event)"
                optionLabel="name"
                optionValue="name"
                optionDisabled="status"
                placeholder="Quad Report 4">
              </p-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 form-group has-float-label mb-4">
            <p-button label="Save" (onClick)="addSaleOrderHeaderData()" />
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="p-wrapper-custom pagination-order py-5 zero-right-pagination">
  <header
    class="samplepo-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>Dashboard Setting</h1>
    <div class="samplepo-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportQuadReport1()">Export excel</a>
      </div>
    </div>
  </header>
</div> -->
